const state = {
    uploadFileListStatus: false,
    modelViewsStatus: false,
};

const actions = {
};

const mutations = {
    SET_FILELIST_STATUS(state, status) {
        state.uploadFileListStatus = status;
    },
    SET_MODELVIEWS_STATUS(state, status) {
        state.modelViewsStatus = status;
    },
};

export default {
    state,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/fileMng.js